module.exports = __webpack_public_path__ + "static/img/M_SHOES.0fb9559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M_SHOES.jpg
// module id = sX1M
// module chunks = 1